module.exports = __webpack_public_path__ + "img/Tosee_Saderat.36295dc1.svg";